export default __webpack_public_path__ + "static/media/CAIC Briefkopf 2023.b899dfb2.png";